import { Injectable } from '@angular/core';
import { ActorRemoteControllerService } from 'core/api';
import { IActorDto } from 'core/dto';
import { RemoteItemService, RemoteItemStore } from 'core/remotes';
import { mapKey } from 'core/rx-js';
import { LoaderService } from 'core/services';
import { filter, takeUntil } from 'rxjs';
import { DsgDeepTranslationKey } from '../../../pipes/translate.pipe';
import { IActor } from '../dto-map/i-actor';
import { ActorHueService } from '../services/actor-hue.service';
import { RemoteActivityService } from './remote-activity.service';
import applyEntityLoader from './utils/apply-entity-loader';


const actorEntityLoader = applyEntityLoader('actor');

const initRemoteStore = (actorRemoteControllerService: ActorRemoteControllerService, loaderService: LoaderService<DsgDeepTranslationKey>) =>
  new RemoteItemStore<IActorDto, string>({
    keyField: 'id',
    load: (id) => actorEntityLoader({
      obs: actorRemoteControllerService.getOne(id),
      loaderService,
      methodKey: 'load'
    }),
    insert: (insertDto) => actorEntityLoader({
      obs: actorRemoteControllerService.create(insertDto)
        .pipe(mapKey('id')),
      loaderService,
      methodKey: 'insert'
    }),
    update: (id, updateDto) => actorEntityLoader({
      obs: actorRemoteControllerService.update(id, updateDto),
      loaderService,
      methodKey: 'update'
    }),
    remove: (id) => actorEntityLoader({
      obs: actorRemoteControllerService.remove(id),
      loaderService,
      methodKey: 'remove'
    }),

  })

@Injectable()
export class RemoteActorService extends RemoteItemService<IActorDto, IActor, string> {


  constructor(
    private readonly _loaderService: LoaderService<DsgDeepTranslationKey>,
    private readonly _actorRemoteControllerService: ActorRemoteControllerService,
    private readonly _actorHueService: ActorHueService,
    private readonly _remoteActivityService: RemoteActivityService
  ) {

    super();
    const customStore = initRemoteStore(this._actorRemoteControllerService, this._loaderService);
    super.setConfig({
      customStore,
      map: (actor) => {
        return actor ? { ...actor, hue: this._actorHueService.getHue(actor?.id) } : actor as IActor
      },
      unMap: (actor) => {
        delete actor.hue;
        return actor as IActorDto;
      },
      dontSync: true
    })

    this.localItemStore.stateSubject
      .pipe(filter(Boolean), takeUntil(this._destroy))
      .subscribe((actor) => {
        const activityLocalCollection = this._remoteActivityService.localCollectionStore
        const activities = activityLocalCollection.stateSubject.value;

        const activity = activities.find(({ id }) => actor.activityId === id);
        if (activity?.actor === actor) {
          return;
        }

        activityLocalCollection.updateOne(actor.activityId, {
          ...activity,
          actor
        })

      })
  }




  ngOnDestroy() {

    super.dispose();
  }
}
